import classNames from "classnames";
import React from "react";
const Label = ({
  label,
  htmlFor,
  isError,
  wuiltContext
}) => {
  const theme = wuiltContext?.props?.theme;
  if (!label) return null;
  return /*#__PURE__*/React.createElement("label", {
    id: "general-text",
    className: classNames(theme && "general-input-label"),
    htmlFor: htmlFor,
    style: {
      display: "block",
      marginBottom: "6px",
      fontSize: "14px",
      color: isError ? "#d92d20" : undefined
    }
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: label ?? ""
    }
  }));
};
export default Label;
//# sourceMappingURL=Label.js.map